import React from 'react'
import { makeStyles } from '@material-ui/core'
import TaskContentContainer from '../tasks/TaskContentContainer'

import navigateToGoSite from '../../../helpers/NavigateToGoSite'
import EquipmentTable from './EquipmentTable';

const GuideGearUp = () => {
  const classes = useStyles()
  return (
    <TaskContentContainer>
      <div className={classes.container}>
        <p>
          On your journey to a fitter, leaner and much stronger you, it will make the world of difference if you have
          the right mindset, and what helps that mindset is if you feel mentally confident and physically supported,
          that’s what ‘Gear Up’ is all about.
        </p>
        <p>
          <b>What you&apos;ll Need:</b>
        </p>
        <ol>
          <li>
            Trainers - A good pair of properly fitted trainers that feel comfortable and offer you the right amount of
            support are essential, especially if you’ll be on your feet with walking, running or any or the workout
            videos.
          </li>
          <li>
            Comfortable Training Gear - Whether you’re at home, in a gym or out at the park - comfort is key. You should
            have clothes that aren’t too hot, cool or tight. I always like to do a few full squats and star jumps in the
            dressing room before I buy workout gear aka Activewear.
          </li>
          <li>
            Equipment - If you’re training at home or outdoors then you’ll need: Some light dumbbells which you can make
            from a couple of water bottles and some rice. There is other nice-to-have equipment such as: a barbell and
            resistance band but all you really need is a can-do attitude and some simple improvisation. PS A good drink
            bottle will be essential to replace all that sweat.
          </li>
        </ol>
        <p>
          <b>How often you&apos;ll be Training</b>
        </p>
        <ul>
          <li>
            <b>Move & Move 2:</b> 4 days of training includes fitness, toning, core and stretch (after Week 8)
          </li>
          <li>
            <b>Beginner, Intermediate & Advanced:</b> 6 days of training includes fitness, toning, core and stretch
          </li>
          <li>
            <b>Lean & Strong:</b> 6 days of training includes strength, toning, fitness/fat burning and core and stretch
          </li>
          <li>
            <b>Running:</b> 6 days of training includes running, toning (strength & stability), core and stretch.
          </li>
          <li>
            <b>Perimenopause:</b> 5 days of training includes strength, agility and pilates
          </li>
          <li>
            <b>Menopause:</b> 5 days of training includes strength, cardio, circuit, and pilates
          </li>
          <li>
            <b>Future Proof:</b> 5 days of training includes strength, mobility and dance.
          </li>
        </ul>
        <p><b>Training Equipment</b></p>
        <p><EquipmentTable /></p>
        <p>
          <b>Bonus Training Equipment</b>
        </p>
        <p>
          &nbsp;These items are optional, but they can be helpful if you’re working out at home and want to try all the workout videos:
        </p>
        <ul>
          <li>Resistance band</li>
          <li>Barbell set</li>
          <li>Swiss Ball</li>
          <li>Heart rate monitor – we recommend one that tracks calories burned</li>
        </ul>
        <p>
          <b>Locations to train at</b>
        </p>
        <p>
          <b>Gym</b> - Before you go to the gym check out this 1 minute video -{' '}
          <a href={navigateToGoSite('videos/category/fitness/450-first-time-to-the-gym')}>Be Gym Ready</a>
        </p>
        <p>
          <b>At Home</b> - Have a couple sets of dumbbells, a mat or towel to door your floor exercises.
        </p>
        <p>
          <b>Outdoors</b> - Similar equipment to ‘At Home’ as well as a sunshine dance.
        </p>
      </div>
    </TaskContentContainer>
  )
}

const useStyles = makeStyles((theme) => ({}))

export default GuideGearUp
